import './components/smooth-scroll'
import './components/sliders'
import './components/popup'
import './components/validation'
import './components/card'
import './components/iconAnimation'
